import styled from "styled-components";

export const PrintSection = styled.section`
  //padding: 50px 0px;
`;

export const TopTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 50px;
  .underbar {
    opacity: 1;
    border: 3px solid #3bb77e;
    width: 60px;
    margin: 5px 0px;
  }
  @media screen and (min-width: 992px) {
    & h4 {
      font-size: 40px;
    }
    .underbar {
      margin: 15px 0px 0px 0px;
    }
  }
`;

export const StrengthWarpper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding: 0px 20px;
  margin-bottom: 50px;
  @media screen and (min-width: 992px) {
    margin-bottom: 100px;
  }
`;

export const StrengthBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    margin-bottom: 16px;
  }
  & p {
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    word-break: keep-all;
    margin: 0px;
    @media screen and (min-width: 768px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

export const StrengthSliderWrapper = styled.div`
  margin-bottom: 60px;
  position: relative;
  .strengthSection {
    display: none;
    background-color: #f4f4f4f4;
    @media screen and (min-width: 992px) {
      display: block;
    }
  }
  .swiperSection {
    position: relative;
    @media screen and (min-width: 992px) {
      display: none;
    }
  }
  .swiper-slide {
    padding: 24px;
    @media screen and (min-width: 768px) {
      padding: 24px 0px;
    }
  }
  .slider-arrow {
    display: none;
    .slider-btn {
      background-color: #fff;
      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
      :hover {
        background-color: #3bb77e;
      }
    }
    @media screen and (min-width: 768px) {
      display: block;
    }
  }
  .swiper-pagination {
    bottom: -10px;
    /* .swiper-pagination-bullet {
      width: 10px !important;
      height: 10px !important;
    } */
  }
  @media screen and (min-width: 992px) {
    margin-bottom: 0px;
  }
`;

export const StrengthPC = styled.div`
  padding: 65px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > h6 {
    color: #2b2b2b !important;
    font-size: 30px;
    font-weight: 700;
    margin: 0px 0px 50px;
    & strong {
      color: #3bb77e;
    }
  }
  .strengthGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    .content {
      overflow: hidden;
      border-radius: 19px;
      background: #fff;
      box-shadow: 3px 6px 10px 0px rgba(0, 0, 0, 0.25);
      padding: 20px;
      > img {
        margin-bottom: 10px;
      }
      .desc {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 0px;
        text-align: center;
        > h6 {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 10px;
        }
        > span {
          font-size: 16px;
          word-break: keep-all;
        }
      }
    }
  }
`;

export const StrengthSlide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  border-radius: 11px;
  background: #f9f9f9;
  box-shadow: 3px 3px 11px 0px rgba(160, 160, 160, 0.25);
  > h6 {
    color: #2b2b2b !important;
    font-weight: 700;
    margin: 16px 0px;
    & strong {
      color: #3bb77e;
    }
    @media screen and (min-width: 768px) {
      font-size: 24px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: 768px) {
      > img {
        max-width: 360px;
      }
    }
  }
  .desc {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    > h6 {
      font-size: 14px;
      margin-bottom: 10px;
    }
    > span {
      font-size: 12px;
      line-height: 16px;
      word-break: keep-all;
      text-align: center;
    }
    @media screen and (min-width: 768px) {
      > h6 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      > span {
        font-size: 16px;
        word-break: keep-all;
      }
    }
  }
`;

export const DesignBanner = styled.div`
  display: flex;
  flex-direction: column;
  //margin-top: 50px;
  /* margin-bottom: 50px; */
  padding: 25px;
  background-color: #3bb77e;
  color: #fff;
  align-items: center;

  .textContent {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  & h6 {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px;
    word-break: keep-all;
    text-align: center;
  }
  & span {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    word-break: keep-all;
    text-align: center;
    margin-bottom: 16px;
  }
  & a {
    background-color: transparent;
    border-radius: 18px;
    border: 1px solid #fff;
    color: #fff;
    padding: 5px 15px;
    font-weight: 700;
    :hover {
      background-color: #fff;
      color: #3bb77e;
    }
  }
  .pc_banner {
    display: none;
  }
  @media screen and (min-width: 768px) {
    & h6 {
      font-size: 22px;
    }
    & span {
      font-size: 17px;
    }
    & button {
      padding: 5px 25px;
    }
  }
  @media screen and (min-width: 992px) {
    flex-direction: row;
    padding: 0px 25px;
    .m_banner {
      display: none;
    }
    .pc_banner {
      display: block;
    }
    .textContent {
      max-width: 1140px;
      margin: 0 auto;
      align-items: flex-start;
      & span {
        text-align: start;
      }
    }
    .content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
    }
    & h6 {
      font-size: 26px;
    }
    & span {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 30px;
    }
    & button {
      padding: 5px 50px;
    }
  }
`;

export const PriceDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;

  @media screen and (min-width: 992px) {
    align-items: flex-start;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
  > div {
    position: relative;
  }
  .arrow {
    margin-bottom: 20px;
  }
  .stepDeco {
    position: absolute;
    border-right: 4px solid #3bb77e;
    height: 100%;
    left: -17px;
    top: 17px;
    display: none;
  }
  .title {
    color: #3bb77e;
    font-size: 18px;
    font-weight: 700;
    position: relative;
    .titleDeco {
      position: absolute;
      top: 6px;
      left: -26px;
      z-index: 10;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 0px 5px 0px;
      line-height: 13px;
      vertical-align: text-top;
      display: none;
    }
  }
  & h6 {
    word-break: keep-all;
    text-align: center;
    margin-bottom: 14px;
    font-size: 16px;
    font-weight: 600;
  }
  & p {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    word-break: keep-all;
    margin-bottom: 20px;
  }
  .pc_direction {
    display: none;
  }
  .m_direction {
    display: inline;
  }
  @media screen and (min-width: 768px) {
    .title {
      font-size: 24px;
    }
    & h6 {
      font-size: 20px;
    }
    & p {
      font-size: 14px;
      line-height: 18px;
    }
  }
  @media screen and (min-width: 992px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 50px;
    .pc_direction {
      display: inline;
    }
    .m_direction {
      display: none;
    }
    .title {
      font-size: 24px;
      .titleDeco {
        display: block;
      }
    }
    & h6 {
      text-align: start;
      margin-bottom: 14px;
      font-size: 20px;
    }
    & p {
      font-size: 18px;
      line-height: 22px;
      text-align: start;
      margin-bottom: 50px;
    }
    .arrow {
      display: none;
    }
    .stepDeco {
      display: block;
    }
  }
`;

export const PriceChart = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 10px;

  .info {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
  }
  .warning {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    color: #ff0000;
  }
  @media screen and (min-width: 992px) {
    .info {
      font-size: 16px;
    }
    .warning {
      margin-top: 10px;
      font-size: 16px;
    }
  }
`;

export const ConfirmBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px auto;
  border: none;
  border-radius: 10px;
  background: #3cb780;
  color: #fff;
  padding: 7px 50px;
  font-size: 16px;
  :hover {
    opacity: 0.8;
  }
  @media screen and (min-width: 992px) {
    padding: 10px 80px;
  }
`;

// products list
export const TableTypeWrapper = styled.div`
  display: flex;
`;

export const Table = styled.table`
  color: #253d4e;
  .header {
    background-color: #f9f6f6ba;
  }
  & tr {
    text-align: center;
    :hover {
      background-color: #f9f6f6ba;
    }
  }

  & th {
    padding: 5px;
    font-size: 14px;
    word-break: keep-all;
  }

  & td {
    padding: 10px;
  }

  & a {
    color: #253d4e;
  }

  .img {
    width: 10%;
    padding: 5px;
    & a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .name {
    width: 35%;
    & a {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      word-break: keep-all;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .price {
    color: #dc3545;
  }

  .btnWrapper {
    width: 10%;
  }

  .form-check-label::before {
    margin: 0;
  }
  .custome-checkbox {
    width: fit-content;
  }

  @media (max-width: 1199px) {
    & td {
      white-space: nowrap;
    }
    .name {
      width: 25%;
    }
  }
  @media (max-width: 991px) {
    & th {
      font-size: 12px;
    }
    & td {
      font-size: 12px;
      padding: 5px;
      white-space: nowrap;
    }
    .name {
      width: 30%;
    }
    .sizes {
      width: 10%;
    }
    .onePrice {
      display: none;
    }
    .quantity {
      width: 10%;
    }
    .price {
      width: 13%;
    }
  }
  @media (max-width: 575px) {
    & th {
      font-size: 10px;
    }
    & td {
      font-size: 10px;
      padding: 5px;
    }
    .name {
      width: 35%;
    }
    .sizes {
      display: none;
    }
    .print_price {
      width: 10%;
    }
    .total_price {
      width: 10%;
    }
  }
  @media (max-width: 460px) {
    .quantity {
      display: none;
    }
    .onePrice {
      display: none;
    }
  }
`;

export const PriceBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;

  & > div {
    & span {
      text-decoration: line-through;
      color: #6c757d;
      opacity: 0.5;
    }
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  word-break: keep-all;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 1.5;
  }
  @media (max-width: 767px) {
    font-size: 10px;
  }
  @media (max-width: 575px) {
    font-size: 8px;
  }
`;

export const ProductInfoFeature = styled.div``;

export const ProductSizeBox = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  margin: 50px 0px;
`;

export const NormalTitle = styled.h3`
  font-size: 31px;
  font-weight: 400;
  line-height: 37.52px;
  text-align: center;
  color: #3e3e3f;
  margin: 50px 0px 50px;
  word-break: keep-all;
  text-align: center;
`;

export const NumberUnderBarTitle = styled.h6`
  width: fit-content;
  font-size: 28px;
  font-weight: 900;
  line-height: 33.89px;
  color: #000000;
  margin: 25px auto;
  position: relative;
  ::after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0%;
    bottom: -5px;
    border-bottom: 3px solid #000000;
  }
`;

export const BoldSmallTitle = styled.h6`
  font-size: 28px;
  font-weight: 900;
  line-height: 33.89px;
  text-align: center;
  word-break: keep-all;
`;

export const MediumTitle = styled.h3`
  width: fit-content;
  font-size: 31px;
  font-weight: 400;
  line-height: 37.52px;
  color: #3e3e3f;
  margin: 0px auto 25px;
  word-break: keep-all;
  text-align: center;
`;

export const TitleDesc = styled.span`
  font-size: 18px;
  font-weight: 400;
  line-height: 21.78px;
  width: fit-content;
  margin: 0 auto 25px;
  color: #3e3e3f;
  word-break: keep-all;
  text-align: center;
`;

export const ImgGridWrapper = styled.div`
  width: ${(props) => (props.length > 1 ? "100%" : "550px")};
  display: grid;
  grid-template-columns: ${(props) =>
    props.length > 1 ? "repeat(2, 1fr)" : "repeat(1, 1fr)"};
  gap: 25px;
  margin: 25px auto;

  @media (max-width: 767px) {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ImgBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  & img {
    height: 390px;
    background-color: #d9d9d9;
    margin-bottom: 20px;
  }
  & span {
    color: #3e3e3f;
    font-size: 15px;
    font-weight: 400;
    line-height: 18.15px;
    word-break: keep-all;
  }
  @media (max-width: 550px) {
    & img {
      height: auto;
    }
  }
`;

export const SmallImgGridWrapper = styled.div`
  width: 75%;
  display: grid;
  grid-template-columns: ${(props) =>
    props.length > 1 ? "repeat(2, 1fr)" : "repeat(1, 1fr)"};
  gap: 50px;
  margin: 0px auto;
  @media (max-width: 767px) {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SmallImgBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & img {
    width: 100%;
    max-width: 394px;
    height: 274px;
    background-color: #d9d9d9;
    margin-bottom: 20px;
  }
  & span {
    color: #3e3e3f;
    font-size: 20px;
    line-height: 24.2px;
    font-weight: 400;
    text-align: center;
  }
`;

export const ProductInfoSize = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  padding-bottom: 50px;
  //border-bottom: 1px solid #dee2e6;
`;

export const SizeTabWrapper = styled.div`
  display: flex;
  margin-bottom: 50px;
`;

export const SizeTab = styled.div`
  width: 100%;
  max-width: 230px;
  padding: 0px 15px;
  height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: ${(props) =>
    props.active ? "2px solid #3bb77e" : "1px solid #d1d1d1"};
  color: ${(props) => (props.active ? "#3bb77e" : "")};
  z-index: ${(props) => (props.active ? "5" : "0")};
  white-space: nowrap;
  @media (max-width: 991px) {
    display: none;
  }
`;

export const SizeSelect = styled.div`
  width: 100%;
  display: none;
  justify-content: center;
  align-items: center;
  @media (max-width: 991px) {
    display: flex;
  }
`;

export const DesignGuide = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImgGuideWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 30px;

  & img {
    grid-column: span 7;
    width: 100%;
    height: 400px;
  }

  .description {
    grid-column: span 5;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 18px;
      font-weight: 700;
      line-height: 21.78px;
      color: #000;
      margin-bottom: 10px;
    }

    .desc {
      font-size: 15px;
      font-weight: 400;
      line-height: 20px;
      color: #3e3e3f;
      word-break: keep-all;
    }
    .danger {
      display: flex;
      align-items: start;
      font-size: 15px;
      font-weight: 400;
      color: #ff0000;
      & i {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
      }
      word-break: keep-all;
    }
  }
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    & img {
      width: 100%;
      height: auto;
    }
  }
`;

export const DesignGuideDownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .ment {
    font-size: 14px;
    font-weight: 400;
    color: #3e3e3f;
    margin: 50px 0px 30px;
  }

  .downloadBtn {
    margin-bottom: 50px;
    border: 3px solid #3bb77e;
    color: #3bb77e;
    background: #ffffff;
    width: 166px;
    height: 50px;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.94px;
    display: flex;
    justify-content: center;
    align-items: center;
    & i {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }
    :hover {
      background-color: #3bb77e;
      color: #fff;
    }
  }
`;

export const TabContainer = styled.div`
  position: sticky;
  top: 72px; // 데스크톱 기본값
  left: 0;
  width: 100%;
  background-color: white;
  z-index: 56;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  @media (max-width: 1200px) {
    top: 104px;
  }

  @media (max-width: 1024px) {
    top: 68px; // 태블릿용 값 조정
  }

  @media (max-width: 768px) {
    top: 68px; // 모바일용 값 조정
  }
`;

export const TabHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-wrap: wrap; /* Allow items to wrap to a new line */
    justify-content: flex-start; /* Align tabs from the start in mobile */
    padding: 0 10px; /* Add some padding on the sides */
    max-height: none; /* Remove max-height restriction */
    overflow-x: visible; /* Remove horizontal scroll */
    white-space: normal; /* Allow text to wrap */
  }
`;

export const TabItem = styled.button`
  padding: 15px 25px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  color: ${(props) => (props.active ? "#000" : "#666")};
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${(props) => (props.active ? "#000" : "transparent")};
    transition: all 0.3s ease;
  }

  &:hover {
    color: #000;
  }

  @media (max-width: 768px) {
    padding: 10px 5px;
    font-size: 14px;
    flex-shrink: 0;
    flex-basis: 25%; /* Make each tab take up one-third of the container width */
    text-align: center;

    /* Adjust the active indicator for the two-row layout */
    &:after {
      bottom: 0;
    }
  }

  /* For very small screens, still keep three per row */
  @media (max-width: 480px) {
    padding: 8px 2px;
    font-size: 13px;
    flex-basis: 25%; /* Keep as one-third for three columns */
  }
`;
